import moment from "moment";

export const formatDateString = (date) => moment(date).format("ddd D MMM"); // example: Tue 9 Jun

export const getDateRangeString = ({ startDate, endDate }) => {
  const dateRangeString = startDate && `${formatDateString(startDate)} - ${formatDateString(endDate)}`;
  return dateRangeString;
};


// WEBPACK FOOTER //
// ./assets/shared/utils/formatDates.js